import Config from '../utils/Config';
import SoundManager from '../utils/SoundManager';
import LocaleManager from '../utils/LocaleManager';
import StateButton from './StateButton';
import SwitchButton from './SwitchButton';

class SettingsPanel extends Phaser.Group {

    constructor(game)
    {
        super(game);

        this.onChange = new Phaser.Signal();

        let optionsGroup = new Phaser.Group(game);
        this.addChild(optionsGroup);

        let musicCheckbox = this._musicCheckBox = new SwitchButton(game, 0, 0, 'buttons.checkbox');
        musicCheckbox.onSwitch.add((target, value) =>
        {
            this.onChange.dispatch('music', value);
        });
        musicCheckbox.checked = SoundManager.music;        
        optionsGroup.addChild(musicCheckbox);

        let musicLabel = new Phaser.Text(game, 0, musicCheckbox.y + (musicCheckbox.height >> 1) + 2, LocaleManager.getString('music'), {
            fill: '#FFFFFF',
            fontSize: 14,
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold'
        });
        musicLabel.anchor.set(0, 0.5);
        optionsGroup.addChild(musicLabel);

        let soundsCheckbox = this._soundCheckBox = new SwitchButton(game, musicCheckbox.x, musicCheckbox.y + musicCheckbox.height + 10, 'buttons.checkbox');        
        soundsCheckbox.onSwitch.add((target, value) =>
        {
            this.onChange.dispatch('sound', value);
        });
        soundsCheckbox.checked = SoundManager.sound;        
        optionsGroup.addChild(soundsCheckbox);

        let soundLabel = new Phaser.Text(game,  0, soundsCheckbox.y + (soundsCheckbox.height >> 1) + 2, LocaleManager.getString('sound_effects'), {
            fill: '#FFFFFF',
            fontSize: 14,
            font: Config.DEFAULT_FONT,
            fontWeight: 'bold'
        });
        soundLabel.anchor.set(0, 0.5);
        optionsGroup.addChild(soundLabel);

        let maxLabelWidth = Math.max(musicLabel.width, soundLabel.width);
        musicCheckbox.x = soundsCheckbox.x = maxLabelWidth + 30 - musicCheckbox.getLocalBounds().x;

        let rect = new Phaser.Graphics(game, 0, 0);
        let optionsGroupBounds = optionsGroup.getLocalBounds();
        rect.beginFill(0);
        rect.drawRect(0, 0, optionsGroupBounds.width + 40, optionsGroupBounds.height + 40);
        rect.endFill();
        this.addChildAt(rect, 0);

        optionsGroup.position.set(
            rect.width - optionsGroupBounds.width >> 1,
            (rect.height - optionsGroupBounds.height >> 1)
        );

        let arrow = new Phaser.Graphics(game, 0, 0);
        arrow.beginFill(0);
        arrow.drawTriangle([
            new Phaser.Point(0, 0),
            new Phaser.Point(8, -8),
            new Phaser.Point(16, 0),
            new Phaser.Point(0, 0)
        ]);
        arrow.endFill();
        arrow.position.set(rect.width - arrow.width >> 1, 0);
        this.addChild(arrow);
    }
    
    toggle(value)
    {
        if (value === undefined)
        {
            value = !this.visible;
        }

        if (value === this.visible)
        {
            return;
        }

        this.visible = value; 
        
        leanderGMApi.publishEvent(leanderGMApi.publications.CONTROL_PANEL_STATUS_CHANGED_GAME, value);
    }
    
    isOpen()
    {
        return this.visible;
    }    
}

export default class TopButtonsPanel extends Phaser.Group {

    constructor(game)
    {
        super(game);

        let onAction = this.onAction = new Phaser.Signal();

        let help = this._help = new StateButton(game, 0, 0, 'buttons.help', () =>
        {
            onAction.dispatch(this, 'help');
        });

        let home = new StateButton(game, 0, 0, 'buttons.home', () =>
        {
            onAction.dispatch(this, 'home');
        });
        home.enabled = !!Config.LOBBY_URL;

        let settings = this._settings = new StateButton(game, 0, 0, 'buttons.settings', this._onClickSettings, this);
        let buttons = this._buttons = [help, home, settings];

        let dX = 0;
        for (let i = 0, len = buttons.length; i < len; i++)
        {
            let button = buttons[i];
            button.position.set(dX - (button.hitArea ? button.hitArea.x : 0), button.hitArea ? -button.hitArea.y : 0);
            dX += (button.hitArea ? button.hitArea.width : button.width) + 10;
            this.addChild(button);
        }

        
        let settingsPanel = this._settingsPanel = new SettingsPanel(game);
        settingsPanel.position.set(
            settings.x + (settings.width >> 1) - (settingsPanel.width >> 1),
            settings.y + (settings.height >> 1) + (settings.hitArea.height >> 1) + settings.hitArea.y - 2
        );
        settingsPanel.onChange.add((what, value) =>
        {
           onAction.dispatch(this, what, value);
        });
        settingsPanel.visible = false;
        this.addChild(settingsPanel);

        this.game.input.onDown.add(this._onGameInputDown, this);
    }

    _onGameInputDown(event)
    {
        if (!this._settingsPanel.visible)
        {
            return;
        }

        let hitTestEvent = () =>
        {
            let boundsEvent = new Phaser.Rectangle(event.x, event.y, 1, 1);
            let boundsView = this._settingsPanel.getBounds();
            let boundsButtonToggle = this._settings.getBounds();
            let intersectsWithToggle = Phaser.Rectangle.intersects(boundsEvent, boundsButtonToggle);
            let intersectsWithBGD = Phaser.Rectangle.intersects(boundsEvent, boundsView);
            return intersectsWithToggle || intersectsWithBGD;
        };

        this._settingsPanel.toggle(hitTestEvent(event));
    }

    _onClickSettings()
    {
        SoundManager.playSound('sounds/touch');
        this._settingsPanel.toggle(!this._settingsPanel.isOpen());
    }
    
    get enabled()
    {
        return !!this._enabled;
    }

    set enabled(value)
    {
        this._help.enabled = this._enabled = !!value;
        //this._buttons.forEach((button) =>
        //{
        //   button.enabled = this._enabled;
        //});
    }
}
